<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">服务人员</el-breadcrumb-item>
            <el-breadcrumb-item>人员列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <!-- <el-form-item label="签约状态">
                    <el-select v-model="formFilter.status" placeholder="请选择状态">
                        <el-option v-for="(item, key) in signStatus" :label="item" :value="key" :key="key"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="身份证号">
                    <el-input v-model="formFilter.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="formFilter.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="formFilter.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter" style="margin-right: 10px;">查询</el-button>
                    <el-button type="default" v-if="exportShow" @click="onExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="data-overview">
                <div class="data-overview__statistics">
                    <div class="statistics-item">总计 <span class="text-primary">{{total}}</span> 人</div>
                    <!-- <div class="statistics-item">待认证 <span class="text-primary">{{unverified}}</span> 人</div> -->
                </div>
                <div class="table-box__tool">
                    <!--                    <el-button plain>导出成员</el-button>-->
                    <!--                    <el-button plain>导出</el-button>-->
                </div>
            </div>
            <div class="table">
                <el-table
                    :data="members"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="name"
                        align="center"
                        label="姓名">
                    </el-table-column>
                    <el-table-column
                        prop="idcard"
                        align="center"
                        label="身份证号">
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        align="center"
                        label="手机号">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="签约时间">
                    </el-table-column>
                    <el-table-column
                        label="自动确认接单"
                        align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.auto_order == 0">
                                    <span class="info">{{signStatus[scope.row.auto_order]}}</span>
                            </template>
                            <template v-if="scope.row.auto_order == 1">
                                <span>{{signStatus[scope.row.auto_order]}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="自动申请结算"
                        align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.auto_apply == 0">
                                <span class="info">{{signStatus[scope.row.auto_apply]}}</span>
                            </template>
                            <template v-if="scope.row.auto_apply == 1">
                                <span>{{signStatus[scope.row.auto_apply]}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="是否绑卡"
                        align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.bank_status == 0">
                                <span class="info">{{bankStatus[scope.row.bank_status]}}</span>
                            </template>
                            <template v-if="scope.row.bank_status == 1">
                                <span>{{bankStatus[scope.row.bank_status]}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click="goPage('/index/member/detail?id='+scope.row.member_id)"
                                       size="medium">详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="10"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            projects: [],
            formFilter: {
                status: '',
                idcard: '',
                name: '',
                phone: ''
            },
            form: {
                status: '',
                idcard: '',
                name: '',
                phone: ''
            },
            members: [],
            total_page: 1,
            signStatus: ['未开启', '已开启'],
            bankStatus: ['未绑卡', '已绑卡'],
            total: 0,
            unverified: 0
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        }),
        preSign () {
            let count = 0
            this.members.forEach((v, k) => {
                if (v.status === 0) {
                    count++
                }
            })
            return count
        },
        preCheck () {
            let count = 0
            this.members.forEach((v, k) => {
                if (v.status === 1) {
                    count++
                }
            })
            return count
        },
        exportShow () {
            return this.members.length > 0
        }
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getMembers()
    },
    methods: {
        getMembers (page = this.currentPage) {
            this.$http.get('/api/user/member/lists', {
                params: {
                    page,
                    size: 10,
                    status: this.formFilter.status,
                    idcard: this.formFilter.idcard,
                    name: this.formFilter.name,
                    phone: this.formFilter.phone
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.members = res.data.listData
                        this.total = res.data.total
                        this.total_page = res.data.total_page
                        this.unverified = res.data.unverified
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        release (member, project) {
            this.$http.get('/api/memberfinished', {
                params: {
                    id: member,
                    project_id: project
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('操作成功')
                        this.getMembers()
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onFilter () {
            this.$store.commit('changeCondition', this.formFilter)
            this.form = Object.assign({}, this.formFilter)
            this.getMembers(1)
        },
        onExport () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downmemberlists?idcard=${this.form.idcard}&name=${this.form.name}&phone=${this.form.phone}&page=${this.currentPage}&size=10`)
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            console.log(eleLink)
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getMembers(e)
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/common.scss";
    @import "../../assets/style/sub.scss";

    .data-overview {
        height: 78px;
    }
</style>
